// extracted by mini-css-extract-plugin
module.exports = {"bg":"navbar_bg__1UKqh","logo":"navbar_logo__3OTuZ","logo_container":"navbar_logo_container__GR_xF","amount":"navbar_amount__9e4km"};